import React, { useEffect, useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import AutoFixOffIcon from '@mui/icons-material/AutoFixOff';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

interface HighlightButtonProps {
  id: string;
  value: string;
  highlighted?: boolean;
  handleHighlightItem: (id: string, value: string) => void;
}

const HighlightButton: React.FC<HighlightButtonProps> = ({
  id,
  value,
  highlighted = false,
  handleHighlightItem,
}) => {
  const [highlightSelected, setHighlightSelected] =
    useState<boolean>(highlighted);

  useEffect(() => {
    if (highlighted !== highlightSelected) setHighlightSelected(highlighted);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [highlighted]);

  return (
    <div>
      <Tooltip title={'Highlight Criteria'} arrow placement="top">
        {!highlightSelected ? (
          <IconButton
            size="small"
            color="warning"
            onClick={() => {
              handleHighlightItem(id, value);
              setHighlightSelected(true);
            }}
          >
            <AutoFixHighIcon fontSize="small" />
          </IconButton>
        ) : (
          <IconButton
            sx={{ color: 'black' }}
            size="small"
            onClick={() => {
              handleHighlightItem(id, value);
              setHighlightSelected(false);
            }}
          >
            <AutoFixOffIcon fontSize="small" />
          </IconButton>
        )}
      </Tooltip>
    </div>
  );
};

export default HighlightButton;
